<template>
  <div class="m-tab-group">
    <div class="m-tab-group__tabs">
      <button v-for="(child, c) in children"
        type="button"
        :key="c"
        @click="child.setActive()"
        class="m-tab-group__tab"
        :class="{ 'is-active': child.isActive }"
        :aria-expanded="child.isActive ? 'true' : 'false'"
        :aria-controls="child.id"
      >
        <span v-text="child.title"></span>
      </button>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      children: [],
    }
  },
  provide() {
    return {
      register: (field) => {
        this.children.push(field)
      },
      unregister: (field) => {
        this.children.splice(this.children.indexOf(field), 1)
      },
      tabChange: (field) => {
        this.children.map((child) => {
          if (child != field) {
            child.hide()
          }
        })
      },
    }
  },
}
</script>
